// @ts-ignore
import * as hoverintent from 'hoverintent';
import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { triggerPublicEvent, PublicEvents, onPublicEvent } from '@project/shared/utils/events/js/events';
import getCurrentBreakpoint, { onBreakpointChange } from '@project/shared/utils/breakpoints/js/breakpoints';

const widthOfArrow = 22,
	paddingReserve = 0,
	classes = {
		stateActive: 'state-a-navigation-main__item--active',
		layerOpener: 'js-m-navigation-wrapper__item-level1',
		navigationLayerWrapper: 'js-m-navigation-wrapper__layer',
		widthCalculationBase: 'js-m-navigation-wrapper',
		level1OpenLayer: 'js-m-navigation-wrapper__open-layer',
	},
	hoverIntentOptions = {
		timeout: 300,
		interval: 100,
	};

@createModule('NavigationMain')
/**
 * navigation-main module implementation.
 *
 * @author Nele Rabus <nele.rabus@namics.com>
 */
export class NavigationMain extends TerrificSpec {
	me = this;
	start(resolve: Function) {
		const $ctx = $(this._ctx);

		// initially: a) make flyout open with JS   b) calculate flyout position
		this.initNavigationOpening($ctx);

		setTimeout(() => {
			this.initNavigationPositioning($ctx);
		}, 10);

		// onResize recalc flyout positions
		$(window).resize((ev: any) => triggerPublicEvent(PublicEvents.uxResize, this.me, this._ctx, ev));
		onPublicEvent(PublicEvents.uxResize, this._ctx, () => this.initNavigationPositioning($ctx));
		onBreakpointChange(() => this.initNavigationOpening($ctx));

		$(window).on('closeNavigation', (ev: Event) => this.closeNavigation($ctx));

		resolve();
	}
	stop() {}

	// make flyout open
	initNavigationOpening($ctx: JQuery) {
		const viewport = getCurrentBreakpoint() as string;
		if (viewport === 'large' || viewport === 'extra-large') {
			const navigationItemLinks = $(`.${classes.layerOpener}`, $ctx);

			navigationItemLinks.each((i, elem) => {
				hoverintent(
					elem,
					function() {
						$(this).addClass(classes.stateActive);
					},
					function() {
						$(this).removeClass(classes.stateActive);
					}
				).options(hoverIntentOptions);
			});
		}
	}

	closeNavigation($ctx: JQuery) {
		const navigationItemLinks = $(`.${classes.layerOpener}`, $ctx);
		navigationItemLinks.removeClass(classes.stateActive);
	}

	// calculate the position of each flyout in viewport large and extra-large
	initNavigationPositioning($ctx: JQuery) {
		const viewport = getCurrentBreakpoint() as string;
		if (viewport === 'large' || viewport === 'extra-large') {
			$(`.${classes.layerOpener} > .${classes.level1OpenLayer}`, $ctx).each(function(index) {
				const currentFirstLevelNavigationElement = $(this);
				const currentFirstLevelNavigationFlyout = currentFirstLevelNavigationElement
					.parent()
					.find(`.${classes.navigationLayerWrapper}`);

				// in case there is a full width layout, the flyout will be set to left:0 , what is the correct positioning
				const positionOfFirstLevelNavigationElement = currentFirstLevelNavigationElement.position();
				const paddingLeftOfFirstLevelNavigationElement = parseFloat(
					currentFirstLevelNavigationElement.css('padding-left')
				);
				const widthOfOfFirstLevelNavigationElement = currentFirstLevelNavigationElement.width();
				const centerPositionOfNavElement =
					positionOfFirstLevelNavigationElement.left + widthOfOfFirstLevelNavigationElement / 2;
				const widthOfFlyout = currentFirstLevelNavigationFlyout.width();
				let leftOfFlyout =
					centerPositionOfNavElement -
					widthOfFlyout / 2 +
					widthOfArrow / 2 +
					paddingLeftOfFirstLevelNavigationElement / 2;
				const rightOfFlyout = leftOfFlyout + widthOfFlyout;
				const totalUsuableWidth = $(`.${classes.widthCalculationBase}`).width();

				// => flyout would reach over right border
				if (rightOfFlyout > totalUsuableWidth) {
					leftOfFlyout = totalUsuableWidth - widthOfFlyout - paddingReserve;
				}

				// => flyout would reach over left border
				if (leftOfFlyout < 0) {
					leftOfFlyout = 0 + paddingReserve;
				}

				// set 'left' position
				currentFirstLevelNavigationFlyout.css('left', leftOfFlyout);
			});
		} else {
			// delete all so far given 'left' positions
			$(`.${classes.layerOpener} > .${classes.level1OpenLayer}`, $ctx).each(function(index: number) {
				const currentFirstLevelNavigationElement = $(this);
				const currentFirstLevelNavigationFlyout = currentFirstLevelNavigationElement
					.parent()
					.find(`.${classes.navigationLayerWrapper}`);

				currentFirstLevelNavigationFlyout.removeAttr('style');
			});
		}
	}
}
